import React, { createContext, useContext, useMemo } from "react";
import { WebshopApiClient } from "@/react/Webshop/api/WebshopApiClient";
const WebshopApiClientContext = createContext(null);
export function WebshopApiClientProvider({ client, children, }) {
    const apiClient = useMemo(() => {
        return client !== null && client !== void 0 ? client : new WebshopApiClient();
    }, [client]);
    console.log("Type of client", typeof apiClient, apiClient);
    return (React.createElement(WebshopApiClientContext.Provider, { value: apiClient }, children));
}
export function useWebshopApiClient() {
    const client = useContext(WebshopApiClientContext);
    if (!client) {
        throw new Error("useWebshopApiClient must be used inside WebshopApiClientProvider");
    }
    return client;
}
